<div class="card-content" data-testid="card-report-item-container">
  <div class="card-left-wrapper">
    <div class="card-space-left">
      @if (isNeedsAttentionCard) {
      <img class="status-icon"
           src="assets/icons/checkmark-circle-warning.svg"
           alt=""
           data-testid="card-report-item-badge-warning" />
      }
      @else {
      <img class="area-status"
           src="assets/icons/checkmark.svg"
           alt=""
           data-testid="card-report-item-badge-complete" />
      }
    </div>
    <div class="card-left">
      <div [innerHTML]="itemText"
           class="component-name text-truncate-2"
           data-testid="card-report-item-text">
      </div>
    </div>
  </div>
  <div class="card-right">
    <i class="pi pi-chevron-right"></i>
  </div>
</div>
<div [innerHTML]="breadcrumbText"
     class="component-status text-truncate"
     data-testid="card-report-item-breadcrumb">
</div>
